export enum TemplateTypeEnum {
  RECEIPT,
  DIGITAL_MENU,
  TEXT_RECEIPT,
}
export enum TemplateBackgroundTypeEnum {
  COLOR,
  IMAGE,
}
